<i2g-dialog-base
  [title]="'JOB.FILES.CAN_NOT_ATTACH_FILE' | translate"
  [body]="attachFileErrorDescription"
  [secondaryButtonText]="'ACTION.OK' | translate"
  (secondaryButtonClicked)="onSecondaryButtonClicked()"
>
</i2g-dialog-base>
